<div id="advSearch" class="mt-3 mb-3" [ngClass]="loading ? 'visually-hidden': ''">
    <form novalidate class="form-inline" [formGroup]="searchForm">
        <!-- Title/Header -->
        <p-toolbar aria-label="Advanced Search">
            <div class="p-toolbar-group-start">
                <span class="section-header">Advanced Search</span>
            </div>
        </p-toolbar>
        <!-- Search Bar Start -->
        <div class="form-group row mt-3 mb-3">
            <div class="col-sm-2 d-flex align-items-center ">
                <label class="float-end notMobile" for="keywords" id="keywordslabel">
                    <span class="form-label"><i class="pi pi-info-circle"
                            pTooltip="Finds documents with ALL keywords and phrases entered."></i>
                        Search Term(s): </span>
                </label>
                <label class="forMobile" for="keywords" id="keywordslabel">
                    <span class="form-label">
                        Search Term(s): </span>
                </label>
            </div>
            <div class="col-sm-8" id="advSearch">
                <p-autoComplete inputId="keywords" placeholder="Enter Search Term(s) - Searches Content & Properties"
                        formControlName="keywords" id="keywords" ariaLabel="Keywords" [minLength]="3" [maxlength]="500"
                        [suggestions]="aSugs" (completeMethod)="getSuggestions($event)" [showClear]="true" (onClear)="clearKeyword()"
                        (onSelect)="kwSuggestionSelected($event)" fluid size="small"></p-autoComplete>           
            </div>
            <div class="col-sm-1">
                        <p-button label="Search" icon="pi pi-search" styleClass="btn-secondary me-2 p-button-sm" (click)="submitForm()" [disabled]="!searchForm.valid || !isLibSelectionValid || !canSubmit"/>
            </div>
        </div>
        <!-- Search Bar End -->

        <!-- Options Start -->
        <div class="form-group row mt-3 mb-3">
            <div class="col-12 col-sm-2">
                <label class="notMobile" for="libOptions" id="libOptionslabel">
                    <span class="form-label"><i class="pi pi-info-circle"
                            pTooltip="Select the libraries/options for which to conduct the search"></i>
                        Options:</span>
                </label>
                <label class="forMobile" for="libOptions" id="libOptionslabel">
                    <span class="form-label" style="float: left;text-align: left;display: block; width: 100%;;">
                        Options:</span>
                </label>
            </div>
            <div class="col-sm-9">
                    <p-radio-button [value]="constants.indexEHD" name="indexId" formControlName="indexId" label="Electronic Hearing Docket" [ngModel]=""
                        class="me-2" (onClick)="validateLibraries();"></p-radio-button><label class="me-3"><img src="../assets/EHD.png" width="20" style="margin: 0 3px;"/> Electronic Hearing Docket</label>
                    <p-radio-button  [value]="constants.indexSDM" name="indexId" formControlName="indexId" label="Staff Discovery Materials" 
                        class="me-2" (onClick)="validateLibraries();"></p-radio-button><label><img src="../assets/SDM.png" width="20" style="margin: 0 3px;"/>  Staff Discovery Materials</label>
                    <p *ngIf="!isLibSelectionValid" class="text-danger text-sm m-2"><i class="pi pi-ban"></i> You must select at least 1 library to search!</p>
            </div>
            <div class="col-sm-9 offset-2 mt-3">
                <p-checkbox [binary]="true" formControlName="openProceedings" label="Open Proceedings"
                    class="me-2" (onChange)="validateProceedingStatus();"></p-checkbox><label class="me-3" for="openProceedings"><i class="fa-solid fa-box-open" style="color: #425e71;"></i> Open Proceedings</label>
                <p-checkbox [binary]="true" formControlName="closedProceedings" label="Closed Proceedings"
                    class="me-2" (onChange)="validateProceedingStatus();"></p-checkbox><label for="closedProceedings"><i class="fa-solid fa-box" style="color: #425e71;"></i> Closed Proceedings</label>
                <p *ngIf="!isProceedingSelectionValid" class="text-danger text-sm m-2"><i class="pi pi-ban"></i> You must select at least 1 proceeding status to search!</p>
            </div>
        </div>
        <!-- Options End -->

        <!-- Properties Start -->

        <div class="mt-3 mb-2 row">
            <div class="d-flex align-items-top col-sm-2">
                <label class="float-end notMobile">
                <span class="form-label"><i
                        class="pi pi-info-circle"
                        pTooltip="Finds documents with ALL keywords, phrases, and/or date(s) entered for the selected property"></i>
                    Properties:</span>
                </label>
                <label class="forMobile">
                    <span class="form-label">
                        Properties:</span>
                    </label>
            </div>
            <div class="col-sm-9">

                <p-tabs value="0">
                    <p-tablist>
                        <p-tab value="0">
                            <i class="pi pi-info-circle"
                                pTooltip="The search query will use an AND operator between each of the properties in this tab. The document MUST MATCH ALL THE PROPERTIES."></i>
                            All (AND)</p-tab>
                        <p-tab value="1">
                            <i class="pi pi-info-circle"
                                pTooltip="The search query will use an OR operator between each of the properties in this tab. If ANY of these properties match the document it will be returned."></i>
                            Any (OR)</p-tab>
                    </p-tablist>
                    <p-tabpanels>
                        <p-tabpanel value="0">
                            <app-search-property-form [operatorType]="constants.property_operator_all" [mdItems]="mdItems"
                            [headerMsg]="allHeaderMsg" [props]="props(constants.property_operator_all)"
                            [searchForm]="searchForm" (addProperty)="addProp($event);"
                            (removeProperty)="removeProp($event)" (clearProperty)="clearProp($event)"
                            (selectProperty)="selectedProp($event)"></app-search-property-form>
                        </p-tabpanel>
                        <p-tabpanel value="1">
                            <app-search-property-form [operatorType]="constants.property_operator_any" [mdItems]="mdItems"
                            [headerMsg]="anyHeaderMsg" [props]="props(constants.property_operator_any)"
                            [searchForm]="searchForm" (addProperty)="addProp($event);"
                            (removeProperty)="removeProp($event)" (clearProperty)="clearProp($event)"
                            (selectProperty)="selectedProp($event)"></app-search-property-form>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>

                <!-- <p-tabView styleClass="tabview-custom">
                    <p-tabPanel>
                        <ng-template pTemplate="header">
                            <i class="pi pi-info-circle"
                                pTooltip="The search query will use an AND operator between each of the properties in this tab. The document MUST MATCH ALL THE PROPERTIES."></i>
                            &nbsp; All (AND)
                        </ng-template>
                        <app-search-property-form [operatorType]="constants.property_operator_all" [mdItems]="mdItems"
                            [headerMsg]="allHeaderMsg" [props]="props(constants.property_operator_all)"
                            [searchForm]="searchForm" (addProperty)="addProp($event);"
                            (removeProperty)="removeProp($event)" (clearProperty)="clearProp($event)"
                            (selectProperty)="selectedProp($event)"></app-search-property-form>
                    </p-tabPanel>
                    <p-tabPanel>
                        <ng-template pTemplate="header">
                            <i class="pi pi-info-circle"
                                pTooltip="The search query will use an OR operator between each of the properties in this tab. If ANY of these properties match the document it will be returned."></i>
                            &nbsp; Any (OR)
                        </ng-template>
                        <app-search-property-form [operatorType]="constants.property_operator_any" [mdItems]="mdItems"
                            [headerMsg]="anyHeaderMsg" [props]="props(constants.property_operator_any)"
                            [searchForm]="searchForm" (addProperty)="addProp($event);"
                            (removeProperty)="removeProp($event)" (clearProperty)="clearProp($event)"
                            (selectProperty)="selectedProp($event)"></app-search-property-form>
                    </p-tabPanel>

                </p-tabView> -->
            </div>
        </div>

        <!-- Properties End -->

        <!-- Clear/Search Start -->
        <div class="mt-2 row">
            <div class="col-sm-2"></div>
            <div class="col-sm-9 text-center d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-primary me-3 mt-2 ps-5 pe-5" (click)="clearSearch()">
                    <i class="fas fa-circle-xmark"></i> Clear All
                </button>
                <button type="submit" class="btn btn-secondary mt-2 ps-5 pe-5" (click)="submitForm()"
                [disabled]="!searchForm.valid || !isLibSelectionValid || !canSubmit">
                    <i class="fas fa-search"></i> Search
                </button>
            </div>
        </div>
        <!-- Clear/Search End -->
    </form>
    <!-- <p>{{ this.searchForm.value |json }}</p> -->
    <app-search-load-dialog [loadSearchVisible]="loadSearchVisible" (loadSearch)="executeLoadSearch($event)"
        (closeLoadSearch)="closeLoadDialog();"> </app-search-load-dialog>
</div>
<p-toast key="maxprops" position="bottom-left"></p-toast>